__turbopack_context__.v({
  "arcDisclosure": "QR4vGa_arcDisclosure",
  "arcLink": "QR4vGa_arcLink",
  "artworkCaption": "QR4vGa_artworkCaption",
  "catalogueCount": "QR4vGa_catalogueCount",
  "catalogueEmpty": "QR4vGa_catalogueEmpty",
  "catalogueFilters": "QR4vGa_catalogueFilters",
  "catalogueSearch": "QR4vGa_catalogueSearch",
  "catalogueSearchField": "QR4vGa_catalogueSearchField",
  "catalogueToolbar": "QR4vGa_catalogueToolbar",
  "detail": "QR4vGa_detail",
  "detailArtwork": "QR4vGa_detailArtwork",
  "detailArtworkImage": "QR4vGa_detailArtworkImage",
  "detailFigure": "QR4vGa_detailFigure",
  "detailHeader": "QR4vGa_detailHeader",
  "detailHeaderCopy": "QR4vGa_detailHeaderCopy",
  "detailHeaderIllustrated": "QR4vGa_detailHeaderIllustrated",
  "discoveryArticle": "QR4vGa_discoveryArticle",
  "discoveryCard": "QR4vGa_discoveryCard",
  "discoveryDescription": "QR4vGa_discoveryDescription",
  "discoveryFooter": "QR4vGa_discoveryFooter",
  "discoveryMeta": "QR4vGa_discoveryMeta",
  "discoverySubtitle": "QR4vGa_discoverySubtitle",
  "eventCard": "QR4vGa_eventCard",
  "eventFilters": "QR4vGa_eventFilters",
  "eyebrow": "QR4vGa_eyebrow",
  "hero": "QR4vGa_hero",
  "heroArtwork": "QR4vGa_heroArtwork",
  "heroCopy": "QR4vGa_heroCopy",
  "heroImage": "QR4vGa_heroImage",
  "heroInner": "QR4vGa_heroInner",
  "heroLead": "QR4vGa_heroLead",
  "heroTitle": "QR4vGa_heroTitle",
  "lineageNodes": "QR4vGa_lineageNodes",
  "narrativeTable": "QR4vGa_narrativeTable",
  "note": "QR4vGa_note",
  "quickLink": "QR4vGa_quickLink",
  "quickNav": "QR4vGa_quickNav",
  "raceAvatar": "QR4vGa_raceAvatar",
  "raceImage": "QR4vGa_raceImage",
  "raceMembers": "QR4vGa_raceMembers",
  "sagaIntro": "QR4vGa_sagaIntro",
  "sectionTitle": "QR4vGa_sectionTitle",
  "surface": "QR4vGa_surface",
  "tableScroll": "QR4vGa_tableScroll",
  "topicArrow": "QR4vGa_topicArrow",
  "topicBlurb": "QR4vGa_topicBlurb",
  "topicCard": "QR4vGa_topicCard",
  "topicContent": "QR4vGa_topicContent",
  "topicCount": "QR4vGa_topicCount",
  "topicGrid": "QR4vGa_topicGrid",
  "topicHeading": "QR4vGa_topicHeading",
  "topicMedia": "QR4vGa_topicMedia",
});
